import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, UserRound } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TONES = {
  orange: { wrap: 'border-orange-200 bg-orange-50/70', ring: 'border-orange-300', icon: 'text-orange-400' },
  purple: { wrap: 'border-purple-200 bg-purple-50/80', ring: 'border-purple-300', icon: 'text-purple-400' },
};

/**
 * KakoIdentity — mostra avatar + apelido do KAKO ID digitado, para o usuário
 * conferir que é a conta dele antes de pedir o código.
 */
export const KakoIdentity = ({ kakoId, testId = 'kako-identity', tone = 'orange' }) => {
  const t = TONES[tone] || TONES.orange;
  const [state, setState] = useState({ status: 'idle', user: null });

  useEffect(() => {
    const id = (kakoId || '').replace(/\D/g, '');
    if (id.length < 6) { setState({ status: 'idle', user: null }); return undefined; }
    let alive = true;
    setState({ status: 'loading', user: null });
    const t = setTimeout(() => {
      axios.post(`${BACKEND_URL}/api/kako/verify-user`, { kako_id: id })
        .then((r) => {
          if (alive) setState({ status: 'ok', user: r.data.user });
        })
        .catch(() => { if (alive) setState({ status: 'fail', user: null }); });
    }, 500);
    return () => { alive = false; clearTimeout(t); };
  }, [kakoId]);

  if (state.status === 'idle') return null;

  if (state.status === 'loading') {
    return (
      <p className="flex items-center gap-2 text-xs text-slate-500" data-testid={`${testId}-loading`}>
        <Loader2 className="h-3.5 w-3.5 animate-spin" /> Procurando a conta no KAKO…
      </p>
    );
  }

  if (state.status === 'fail') {
    return (
      <p className="text-xs font-medium text-rose-600" data-testid={`${testId}-notfound`}>
        Não encontramos esse KAKO ID. Confira os números.
      </p>
    );
  }

  return (
    <div className={`flex items-center gap-3 rounded-xl border p-2.5 ${t.wrap}`}
      data-testid={testId}>
      {state.user?.avatar
        ? <img src={state.user.avatar} alt="" data-testid={`${testId}-avatar`}
            className={`h-11 w-11 shrink-0 rounded-full border-2 object-cover ${t.ring}`} />
        : <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 bg-white ${t.ring} ${t.icon}`}>
            <UserRound className="h-5 w-5" />
          </span>}
      <div className="min-w-0">
        <p className="truncate text-sm font-bold text-slate-800" data-testid={`${testId}-nickname`}>
          {state.user?.nickname}
        </p>
        <p className="text-xs text-slate-500">KAKO ID {state.user?.id}</p>
      </div>
    </div>
  );
};

export default KakoIdentity;
